module.exports = __webpack_public_path__ + "img/eye-dropper-full.19893bed.svg";